module.exports = __webpack_public_path__ + "img/nutritionist.76083694.png";